import React, { useContext } from 'react';
import { X, ArrowRightFromLine } from 'lucide-react';
import Button from '../../../components/Button';
import GlobalContext from '../../../utils/GlobalContext';

export default function ChatGroupHeaderComponent({
  isExpanded = false,
  title = '',
  onClose,
  onClickExpand,
}) {
  const { locales } = useContext(GlobalContext);
  if (!isExpanded)
    return (
      <Button
        onClick={onClickExpand}
        size="evenDefault"
        variant="ghost"
        aria-label="Expand chat section"
      >
        <ArrowRightFromLine />
      </Button>
    );

  return (
    <div className="flex flex-row items-center align-center gap-6">
      <div className="chat-group-header-component__title text-wrap break-all">
        {locales.chatSystem.header} {title}
      </div>
      <Button
        onClick={onClose}
        size="evenDefault"
        variant="ghost"
        aria-label="Minimise chat section"
      >
        <X />
      </Button>
    </div>
  );
}
